import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import middleware from "../../Api/Middleware";
import Cookies from "universal-cookie";

const sessionCacheUtils = {
  CACHE_KEY: "backoffice_settings_session",
  CACHE_DURATION: 10 * 60 * 1000, // 10 minutes

  setCache: (data) => {
    const cacheData = {
      data: data,
      timestamp: Date.now(),
      expires: Date.now() + sessionCacheUtils.CACHE_DURATION
    };
    sessionStorage.setItem(sessionCacheUtils.CACHE_KEY, JSON.stringify(cacheData));
  },

  getCache: () => {
    try {
      const cached = sessionStorage.getItem(sessionCacheUtils.CACHE_KEY);
      if (!cached) return null;

      const cacheData = JSON.parse(cached);
      
      if (Date.now() > cacheData.expires) {
        sessionStorage.removeItem(sessionCacheUtils.CACHE_KEY);
        return null;
      }

      return cacheData.data;
    } catch (error) {
      console.error("Error reading session cache:", error);
      sessionStorage.removeItem(sessionCacheUtils.CACHE_KEY);
      return null;
    }
  },

  clearCache: () => {
    sessionStorage.removeItem(sessionCacheUtils.CACHE_KEY);
  },

  // Check if cache exists and is valid
  isCacheValid: () => {
    try {
      const cached = sessionStorage.getItem(sessionCacheUtils.CACHE_KEY);
      if (!cached) return false;

      const cacheData = JSON.parse(cached);
      return Date.now() <= cacheData.expires;
    } catch (error) {
      return false;
    }
  }
};

export default function BackofficeRedirectCheck({ navInfo, loading }) {
  const navigate = useNavigate();
  const location = useLocation();
  const cookies = new Cookies();

  useEffect(() => {
    const fetchBackoffice = async () => {
      const token = cookies.get("token");
      if (!token || loading || location.pathname === "/bedrijfsconfiguratie") return;

      try {
        // First, try to get data from session cache
        const cachedData = sessionCacheUtils.getCache();
        
        if (cachedData !== null) {
          // Process cached data the same way as fresh API data
          const isEmpty =
            !cachedData ||
            (Array.isArray(cachedData) && cachedData.length === 0) ||
            (typeof cachedData === "object" && Object.keys(cachedData).length === 0);

          if (isEmpty) {
            navigate("/bedrijfsconfiguratie");
          }
          return; // Exit early, using cached data
        }

        // If no valid cache, fetch from API
        const response = await middleware.get("settings/backoffice");
        const data = response.data.data;

        // Cache the fresh data in session storage
        sessionCacheUtils.setCache(data[0]);

        // Process the fresh data
        const isEmpty =
          !data ||
          (Array.isArray(data) && data.length === 0) ||
          (typeof data === "object" && Object.keys(data).length === 0);

        if (isEmpty) {
          navigate("/bedrijfsconfiguratie");
        }
      } catch (err) {
        console.error("Error fetching backoffice settings:", err);
      }
    };

    fetchBackoffice();
  }, [loading, navInfo, navigate, location.pathname]);

  return null;
}